import AuthenticPlacesMarker from "@/app/features/sites/authentic-places/ui/shared/AuthenticPlacesMarker";
import MiniMap from "@/app/__to_be_integrated/_____components/map/components/minimap/v2/MiniMap";
import { AuthenticPlace } from "@/app/lib/generated/graphql-types";
import { useSplitContent } from "@/app/features/shared/split-content/contexts/SplitContentProvider";

export default function AuthenticPlacesMiniMap({ place }: { place: AuthenticPlace }) {
    const { isHorizontal, isLeading, splitPosition } = useSplitContent();
    return (
        <MiniMap
            mapId={process.env.NEXT_PUBLIC_MAPS_ID_AUTHENTIC_PLACES!}
            fitPoints={[place.location!]}
            slots={{
                root: {
                    sx: {
                        position: 'absolute',
                        left: (theme) => isHorizontal ? (isLeading ? `max(${theme.spacing(10)}, calc(${splitPosition}% + ${theme.spacing(4)}))` : theme.spacing(10)) : theme.spacing(10),
                        minWidth: '150px',
                        maxWidth: (theme) => isHorizontal ? (isLeading ? `calc(100% - max(${theme.spacing(10)}, calc(${splitPosition}% + ${theme.spacing(4)})))` : `calc(calc(100% - ${100-splitPosition}%) - ${theme.spacing(14)})`) : `calc(100% - ${theme.spacing(14)})`,
                        transition: 'left 0.3s easeOut',
                    }
                }
            }}
        >
            <AuthenticPlacesMarker place={place} showRouteDescription />
        </MiniMap>
    )
}